// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Directive, Input, Output, EventEmitter, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
    selector: '[appDebounceInput]',
    standalone: false
})
export class DebounceInputDirective implements  OnInit, OnDestroy {
  @Input() debounceTime = 200;
  @Output() debounceInput = new EventEmitter();
  private input = new Subject();
  private subscription: Subscription;

  ngOnInit() {
    this.subscription = this.input.pipe(
      debounceTime(+this.debounceTime)
    ).subscribe(e => {
      this.debounceInput.emit(e);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('input', ['$event'])
  inputEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.input.next(event);
  }

}
